import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { SessionExpiredHandler } from '@core/auth/session-expired.handler';
import { AppError } from '@core/errors/app-error';

/**
 * Ends the session on HTTP 401. 403 is a permission problem, not an expired session, so it is passed through.
 * A request that never reached the server (status 0) becomes `AppError('network')`: the Apollo HttpLink
 * would otherwise turn it into a plain `Error` and the "server unreachable" case could not be told apart.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionExpired = inject(SessionExpiredHandler);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        sessionExpired.handle();
      }
      if (error instanceof HttpErrorResponse && error.status === 0) {
        return throwError(() => new AppError('network', 'Unable to reach the server.', error));
      }
      return throwError(() => error);
    }),
  );
};
